<template>
  <div class="dashboard__view">
    <div class="page flex-end">
      <div class="relative">
        <div class="text-light">
          <div class="page__title__action d-flex">
            <router-link
              class="btn btn--primary"
              to="/dashboard/statements/upload-history"
              >View Upload History</router-link
            >
          </div>
        </div>
      </div>
      <br />
    </div>

    <div class="list">
      <div class="tab__content">
        <div class="tab__content__top">
          <Tab :tabs="tabs" />
        </div>
        <div>
          <!-- Loader -->
          <div class="card-table">
            <div v-if="$route.name.toLowerCase() === 'createsinglestatement'">
              <create-single-statement />
            </div>
            <div
              v-else-if="$route.name.toLowerCase() === 'createbulkstatement'"
            >
              <create-bulk-statement />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tab from "@/components/tab.vue";
import CreateSingleStatement from "./create/single";
import CreateBulkStatement from "./create/bulk";

export default {
  metaInfo: {
    title: "Create Statement"
  },
  components: {
    Tab,
    CreateSingleStatement,
    CreateBulkStatement
  },
  data() {
    return {
      tabs: [
        {
          url: `/dashboard/statements/create-single`,
          name: "Single Create"
        },
        {
          url: `/dashboard/statements/create-bulk`,
          name: "Bulk Create"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
// filter styles start
.flex-end {
  justify-content: flex-end;
}
.relative {
  position: relative;
}
</style>
